(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rvxb-home-purchase"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.rvxbMobileOffer) return;
  window.rvxbMobileOffer=true;
  function init(){
    const bar=document.createElement('aside');
    bar.className='rvxb-mobile-offer';bar.hidden=true;
    bar.setAttribute('aria-label','Selected subscription offer');
    bar.innerHTML='<div><strong class="rvxb-mobile-offer__name"></strong><span class="rvxb-mobile-offer__billing"></span></div><a class="rvxb-mobile-offer__link"></a>';
    document.body.appendChild(bar);
    const name=bar.querySelector('strong'),billing=bar.querySelector('span'),link=bar.querySelector('a');
    const mobile=window.matchMedia('(max-width:749px)');
    let active=null,frame=0;
    const visible=el=>{const r=el.getBoundingClientRect(),s=getComputedStyle(el);return !el.closest('[hidden],[aria-hidden="true"]')&&r.width>0&&r.height>0&&r.right>0&&r.left<document.documentElement.clientWidth&&r.bottom>0&&r.top<innerHeight&&s.visibility!=='hidden'&&s.display!=='none'&&s.opacity!=='0';};
    function blocked(){
      if(getComputedStyle(document.body).overflowY==='hidden'||getComputedStyle(document.documentElement).overflowY==='hidden') return true;
      if(document.activeElement&&document.activeElement.matches('input:not([type=radio]):not([type=checkbox]),textarea,select')) return true;
      return Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"],[role="dialog"],cart-drawer.active,.drawer.is-open,.drawer--open,.modal.is-open,.modal--open,.klaviyo-form-overlay,.needsclick[role="dialog"],[id*="alia"][data-state="open"],footer,[id^="shopify-section"][id*="footer"],iframe[title*="chat" i],iframe[title*="alia" i]')).some(el=>{
        if(!visible(el)) return false;
        if(el.tagName==='IFRAME'){const r=el.getBoundingClientRect();return r.width>220&&r.height>250;}
        return true;
      });
    }
    function update(){
      frame=0;
      const sections=Array.from(document.querySelectorAll('[data-rvxb-home-purchase]'));
      if(!mobile.matches||!sections.length||blocked()){bar.hidden=true;return;}
      if(!active||!active.isConnected) active=sections[0];
      const near=sections.filter(visible).sort((a,b)=>Math.abs(a.getBoundingClientRect().top-innerHeight*.4)-Math.abs(b.getBoundingClientRect().top-innerHeight*.4))[0];
      if(near) active=near;
      const radio=active.querySelector('input[name="id"]:checked:not(:disabled)');
      if(!radio||sections.every(el=>el.getBoundingClientRect().top>innerHeight)){bar.hidden=true;return;}
      const selector=active.querySelector('.rvxb-offers'),rect=selector.getBoundingClientRect();
      if(rect.top>=80&&rect.bottom<innerHeight-85){bar.hidden=true;return;}
      const offer=radio.closest('.rvxb-offer');
      const title=offer.querySelector('.rvxb-offer-copy strong').textContent.trim();
      const price=offer.querySelector('.rvxb-offer-price strong').textContent.trim();
      const timing=offer.querySelector('.rvxb-offer-price>span').textContent.trim();
      const renewal=offer.querySelector('.rvxb-offer-renewal').textContent.trim();
      const terms=price+' '+timing+' · '+renewal;
      if(name.textContent!==title)name.textContent=title;
      if(billing.textContent!==terms)billing.textContent=terms;
      const label=active.dataset.mobileOfferLabel||'Review offer';
      if(link.textContent!==label)link.textContent=label;
      const href='#'+active.id;if(link.getAttribute('href')!==href)link.setAttribute('href',href);
      link.setAttribute('aria-label',label+': '+title);
      bar.hidden=false;
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    link.addEventListener('click',function(event){
      if(!active)return;event.preventDefault();
      const radio=active.querySelector('input[name="id"]:checked');
      active.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      if(radio)radio.focus({preventScroll:true});
    });
    document.addEventListener('change',function(event){const section=event.target.closest('[data-rvxb-home-purchase]');if(section){active=section;schedule();}});
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
    document.addEventListener('shopify:section:load',schedule);document.addEventListener('shopify:section:unload',schedule);
    new MutationObserver(function(records){if(records.some(record=>!bar.contains(record.target)))schedule();}).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','hidden','aria-hidden','aria-modal','data-state']});
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rvxm-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rvxm-banner')) {
  customElements.define('rvxm-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const video = this.querySelector('video');
      const button = this.querySelector('.rvxm-video-toggle');
      if (!video || !button) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        button.setAttribute('aria-pressed', String(!video.paused));
        button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('[data-play]').hidden = !video.paused;
        button.querySelector('[data-pause]').hidden = video.paused;
      };
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update); else video.pause();
      }, { signal });
      video.addEventListener('play', update, { signal });
      video.addEventListener('pause', update, { signal });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); }, { signal });
      if (button.dataset.autoplay === 'true' && !reduced.matches && !navigator.connection?.saveData) {
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && !this.started) { this.started = true; video.play().catch(update); }
          if (!entry.isIntersecting) video.pause();
        }, { threshold: .1 });
        this.observer.observe(this);
      }
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
if (!window.rivoxMotionEvents) {
  window.rivoxMotionEvents = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rvxm-search[open],.rvxm-mobile-menu[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('shopify:block:select', event => {
    const question = event.target.closest('.rvxm-question');
    if (question) question.open = true;
  });
}
  } catch(e) { console.error(e); }
})();

})();
